// Remove this file during sign_core_2025_12_08_white_labeling_swap FF cleanup

export const whiteLabelingOld = {
  page_background_color: '#f7f8f9',
  header_background_color: '#1a1a1a',
  text_color1: '#808080',
  text_color2: '#ffffff',
  link_color: '#0061FE',
  primary_button_color: '#0061FE',
  primary_button_text_color: '#ffffff',
  primary_button_color_hover: '#0061FE',
  primary_button_text_color_hover: '#ffffff',
  secondary_button_color: '#ffffff',
  secondary_button_text_color: '#0061FE',
  secondary_button_color_hover: '#ffffff',
  secondary_button_text_color_hover: '#0061FE',
  legal_version: 'terms1',
} as const;

export type WhiteLabelingPropertyIdOld = keyof typeof whiteLabelingOld;
